module.exports = __webpack_public_path__ + "img/link-icon.ca42b3c9.svg";